(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HeaderCustom-liquid"]) return;
  try {
    
// assets/theme.js

document.addEventListener('DOMContentLoaded', () => {
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const customMenu = document.querySelector('.custom-menu');
    const menuOverlay = document.createElement('div'); // 创建遮罩层
    menuOverlay.classList.add('menu-overlay');
    document.body.appendChild(menuOverlay); // 将遮罩层添加到 body

    // 移动菜单的打开/关闭
    if (mobileMenuToggle && customMenu && menuOverlay) {
        mobileMenuToggle.addEventListener('click', () => {
            customMenu.classList.toggle('menu-open');
            mobileMenuToggle.classList.toggle('active'); // 汉堡图标动画
            menuOverlay.style.display = customMenu.classList.contains('menu-open') ? 'block' : 'none';
            document.body.classList.toggle('no-scroll'); // 防止页面滚动
        });

        menuOverlay.addEventListener('click', () => {
            customMenu.classList.remove('menu-open');
            mobileMenuToggle.classList.remove('active');
            menuOverlay.style.display = 'none';
            document.body.classList.remove('no-scroll');
        });

        // 在窗口大小变化时关闭移动菜单（从移动端切换到桌面端时）
        window.addEventListener('resize', () => {
            if (window.innerWidth > 768 && customMenu.classList.contains('menu-open')) {
                customMenu.classList.remove('menu-open');
                mobileMenuToggle.classList.remove('active');
                menuOverlay.style.display = 'none';
                document.body.classList.remove('no-scroll');
            }
        });
    }

    // 子菜单的展开/折叠
    const menuItemsWithSub = document.querySelectorAll('.custom-menu__item');

    menuItemsWithSub.forEach(item => {
        const hasSubmenu = item.querySelector('.custom-submenu');
        const mainLink = item.querySelector('a'); // 主菜单链接

        if (hasSubmenu) {
            // 在有子菜单的链接后面添加一个可点击的箭头/图标
            const toggleArrow = document.createElement('span');
            toggleArrow.classList.add('custom-submenu-toggle');
            toggleArrow.textContent = '▶'; // 默认箭头
            mainLink.parentNode.insertBefore(toggleArrow, mainLink.nextSibling); // 插入到主链接后面

            // 阻止主链接在移动端跳转，如果它有子菜单
            // 或者你可以让它先展开子菜单，第二次点击才跳转
            mainLink.addEventListener('click', (e) => {
                if (window.innerWidth <= 768) { // 仅在移动端生效
                    e.preventDefault(); // 阻止默认跳转
                    item.classList.toggle('submenu-open');
                    // 调整子菜单的高度以实现动画
                    const submenu = item.querySelector('.custom-submenu');
                    if (item.classList.contains('submenu-open')) {
                        submenu.style.maxHeight = submenu.scrollHeight + 'px'; // 设置为实际高度
                    } else {
                        submenu.style.maxHeight = '0';
                    }
                }
            });

            // 专门为箭头添加点击事件，以防用户想直接点击箭头展开
            toggleArrow.addEventListener('click', (e) => {
                e.stopPropagation(); // 防止事件冒泡到主链接
                if (window.innerWidth <= 768) {
                    item.classList.toggle('submenu-open');
                    const submenu = item.querySelector('.custom-submenu');
                    if (item.classList.contains('submenu-open')) {
                        submenu.style.maxHeight = submenu.scrollHeight + 'px';
                    } else {
                        submenu.style.maxHeight = '0';
                    }
                }
            });
        }
    });

    // --- 简单的滑动效果 (轻触检测) ---
    // 这个通常用于抽屉菜单的关闭。
    // 在这里，我们可以让用户从左边缘向右滑动来打开菜单，从菜单向左滑动关闭菜单。
    let touchstartX = 0;
    let touchendX = 0;

    function handleGesure() {
        if (touchendX < touchstartX) { // 向左滑动
            if (customMenu.classList.contains('menu-open') && touchstartX - touchendX > 50) { // 阈值50px
                customMenu.classList.remove('menu-open');
                mobileMenuToggle.classList.remove('active');
                menuOverlay.style.display = 'none';
                document.body.classList.remove('no-scroll');
            }
        }
        if (touchendX > touchstartX) { // 向右滑动
            // 如果在页面左侧滑动，且菜单未打开
            if (!customMenu.classList.contains('menu-open') && touchendX - touchstartX > 50 && touchstartX < 50) { // 从屏幕左侧50px范围内开始滑动
                 customMenu.classList.add('menu-open');
                 mobileMenuToggle.classList.add('active');
                 menuOverlay.style.display = 'block';
                 document.body.classList.add('no-scroll');
            }
        }
    }

    document.addEventListener('touchstart', e => {
        touchstartX = e.changedTouches[0].screenX;
    });

    document.addEventListener('touchend', e => {
        touchendX = e.changedTouches[0].screenX;
        handleGesure();
    });
});

// 为了防止移动端页面在菜单打开时滚动，添加一个CSS类
// 在 theme.scss.liquid 中也要定义
/*
body.no-scroll {
    overflow: hidden;
}
*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
